import { nodeToLatex } from "../utils/nodeToLatex";

import type { NodeJson } from "@corca/data";
import type { Node as PMNode } from "@tiptap/pm/model";

export function serializeNode(
  node: NodeJson,
  pmNode: PMNode,
  pmDoc: PMNode,
  parent: PMNode | null,
  pos: number,
): string {
  const latex = nodeToLatex(node);

  // render as a block math expression if it's the only math node in paragraph
  if (
    parent?.type.name === "paragraph" &&
    parent.textContent.trim() === pmNode.textContent.trim()
  ) {
    const respos = pmDoc.resolve(pos);
    let depth = respos?.depth ?? 0;
    let inTable = false;
    let nested = false;
    let { alignment } = parent.attrs;
    while (respos && !inTable && depth > 0) {
      const ancestor = respos.node(depth);
      if (ancestor.type.name === "table") {
        inTable = true;
      }
      if (ancestor.attrs.alignment && !alignment) {
        alignment = ancestor.attrs.alignment as string;
      }
      if (ancestor.type.name !== "paragraph") {
        nested = true;
      }
      depth -= 1;
    }

    if (!inTable) {
      let mathChildCount = 0;
      parent.forEach((child) => {
        if (child.type.name === "inlineExpression") {
          mathChildCount += 1;
        }
      });
      if (mathChildCount === 1) {
        if (alignment === "right") {
          return `\\(\\displaystyle ${latex.text} \\)`;
        }

        if (nested && (!alignment || alignment === "left")) {
          return `\\(\\displaystyle ${latex.text} \\)`;
        }

        return `\\[ ${latex.text} \\]`;
      }
    }
  }

  return `\\( ${latex.text} \\)`;
}
